import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HeaderCategoriesButton } from "@faire/retailer-visitor-shared/components/Header/desktop/HeaderCategoriesDropdown/HeaderCategoriesButton";
import { useNavigationCardQuery } from "@faire/retailer-visitor-shared/components/Header/desktop/HeaderCategoriesDropdown/useNavigationCardQuery";
import { HeaderDesktopLogo } from "@faire/retailer-visitor-shared/components/Header/desktop/HeaderDesktopLogo";
import { LoginSection } from "@faire/retailer-visitor-shared/components/Header/desktop/LoginSection";
import { HeaderCart } from "@faire/retailer-visitor-shared/components/Header/HeaderCart";
import { HeaderSearch } from "@faire/retailer-visitor-shared/components/Header/HeaderSearch";
import { canAddToCart } from "@faire/retailer-visitor-shared/lib/canAddToCart";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useIsSemDiscoverPage } from "@faire/retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { ClientPlatformType } from "@faire/web-api--source/indigofair/data/ClientPlatformType";
import React, { useCallback, useState } from "react";
import styled, { css } from "styled-components";
import { MAX_HEADER_WIDTH } from "../consts";
import { BlogEntryLink } from "./BlogEntryLink";
import { LanguageSelectorSection } from "./LanguageSelectorSection";
import { MarketLinksSection } from "./MarketLinksSection";
import { SellOnFaireLink } from "./SellOnFaireLink";
export var HeaderDesktopContent = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var _useState = _sliced_to_array(useState(false), 2), shouldExpandSearchBar = _useState[0], setShouldExpandSearchBar = _useState[1];
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    var isSemSimplifiedLpEnabled = useIsSemDiscoverPage();
    // prefetch navigation card when navigation redesign is enabled
    useNavigationCardQuery(ClientPlatformType.CLIENT_DESKTOP);
    // This function reference must be stable for page scrolling
    var onSearchFocus = useCallback(function(element, isOnToggle) {
        if (isDesktopAndAbove && isOnToggle) {
            var _element_getBoundingClientRect;
            setShouldExpandSearchBar(!!(element && ((_element_getBoundingClientRect = element.getBoundingClientRect()) === null || _element_getBoundingClientRect === void 0 ? void 0 : _element_getBoundingClientRect.width) < 300));
        }
    }, [
        isDesktopAndAbove
    ]);
    // This function reference must be stable for page scrolling
    var onSearchBlur = useCallback(function() {
        setShouldExpandSearchBar(false);
    }, []);
    return /*#__PURE__*/ _jsxs(Wrapper, {
        justify: "center",
        align: "center",
        $enableRedesign: isLoggedInRetailer,
        children: [
            /*#__PURE__*/ _jsx(HeaderDesktopLogo, {
                omitStyling: isLoggedInRetailer
            }),
            isLoggedInRetailer ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "2x"
                    }),
                    /*#__PURE__*/ _jsx(HeaderCategoriesButton, {}),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "2x"
                    })
                ]
            }) : null,
            isDesktopAndAbove ? /*#__PURE__*/ _jsx(HeaderSearch, {
                onFocus: onSearchFocus,
                onBlur: onSearchBlur,
                inputId: "top-search",
                inputDataTestId: "searchBarInput"
            }) : null,
            /*#__PURE__*/ _jsx(Spacer, {
                width: "2x"
            }),
            !shouldExpandSearchBar && !isSemSimplifiedLpEnabled ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !isLoggedInRetailer ? /*#__PURE__*/ _jsx(LanguageSelectorSection, {}) : null,
                    !isLoggedInRetailer ? /*#__PURE__*/ _jsx(BlogEntryLink, {}) : null,
                    !canAddToCart() ? /*#__PURE__*/ _jsx(SellOnFaireLink, {}) : null,
                    /*#__PURE__*/ _jsx(MarketLinksSection, {})
                ]
            }) : null,
            /*#__PURE__*/ _jsx(LoginSection, {}),
            canAddToCart() ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(HeaderCart, {
                        dataTestId: "headerCartButton"
                    }),
                    isLoggedInRetailer ? null : /*#__PURE__*/ _jsx(Spacer, {
                        width: "3x"
                    })
                ]
            }) : null
        ]
    });
};
var Wrapper = styled(Row).withConfig({
    componentId: "sc-89f8ae44-0"
})([
    "width:100%;",
    ""
], function(param) {
    var $enableRedesign = param.$enableRedesign;
    return $enableRedesign ? css([
        "max-width:",
        "px;margin:auto;",
        "{padding:",
        " ",
        " 0;}"
    ], MAX_HEADER_WIDTH, responsiveMediaQueries.desktopAndAbove, getSpacing("2x"), getSpacing("6x")) : "";
});
